import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// enviroment variables..
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { APIResponse, WhatsupAPIResponse } from "src/app/models/api-model";
const whatAppheaders = new HttpHeaders()
  // .set('content-Type', 'application/x-www-form-urlencoded')
  .set('Content-Type', 'application/x-www-form-urlencoded')
  .set('Access-Control-Allow-Origin', '*')


@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {

  // eforce base url variable declare
  eForceBaseURL = environment.eForceAPIURL;
  headers: HttpHeaders;

  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
    })
  };
  count: any;


  constructor(private http: HttpClient) { }

  loggedIn() {
    return !!localStorage.getItem('token')
  }

  private sanitizeURL(url: string): string {
    if (url.includes('/&')) {
      url = url.replace(/\/&/g, '/?');
    }
    const firstQuestionMarkIndex = url.indexOf('?');
    if (firstQuestionMarkIndex !== -1) {
      const base = url.substring(0, firstQuestionMarkIndex + 1);
      let query = url.substring(firstQuestionMarkIndex + 1);
      query = query.replace(/\?/g, '&');
      url = base + query;
    }
    return url;
  }

  // function for all API request 
  request(requestType: string, requestURL: string, requestBody: any): Observable<APIResponse> {

    // Sanitize URL to prevent double slashes
    let fullURL = this.eForceBaseURL;
    if (requestURL.startsWith('http://') || requestURL.startsWith('https://')) {
      fullURL = requestURL;
    } else {
      const portMatch = requestURL.match(/^:(\d+)(.*)$/);
      if (portMatch) {
        const newPort = portMatch[1];
        const remainingPath = portMatch[2];
        try {
          const u = new URL(this.eForceBaseURL);
          fullURL = `${u.protocol}//${u.hostname}:${newPort}${remainingPath}`;
        } catch (e) {
          const protoIndex = this.eForceBaseURL.indexOf('://');
          if (protoIndex !== -1) {
            const protocol = this.eForceBaseURL.substring(0, protoIndex + 3);
            const domainAndRemaining = this.eForceBaseURL.substring(protoIndex + 3);
            const firstSlashOrColon = domainAndRemaining.search(/[:\/]/);
            const host = firstSlashOrColon !== -1 ? domainAndRemaining.substring(0, firstSlashOrColon) : domainAndRemaining;
            fullURL = `${protocol}${host.replace(/\/$/, '')}:${newPort}${remainingPath}`;
          } else {
            fullURL = this.eForceBaseURL + requestURL;
          }
        }
      } else if (fullURL.endsWith('/') && requestURL.startsWith('/')) {
        fullURL += requestURL.substring(1);
      } else if (!fullURL.endsWith('/') && !requestURL.startsWith('/')) {
        fullURL += '/' + requestURL;
      } else {
        fullURL += requestURL;
      }
    }

    fullURL = this.sanitizeURL(fullURL);

    // for get request..
    if (requestType === 'get') {
      return this.http.get<APIResponse>(fullURL);
    }

    // for post request(adding)..
    if (requestType === 'post') {
      return this.http.post<APIResponse>(fullURL, requestBody);
    }

    // for put request(updating with all required values)..        
    if (requestType === 'put') {
      return this.http.put<APIResponse>(fullURL, requestBody);
    }

    // for patch request(updating with specific values)..
    if (requestType === 'patch') {
      return this.http.patch<APIResponse>(fullURL, requestBody);
    }

    // for delete request..
    if (requestType === 'delete') {
      return this.http.delete<APIResponse>(fullURL);
    }

  }

  // img upload
  imgUpload(requestType: string, requestURL: string, requestBody: any) {
    let finalURL = "";

    if (requestURL.startsWith('http://') || requestURL.startsWith('https://')) {
      finalURL = requestURL;
    } else {
      let baseUrl = "https://eforce-api.cap-tech.in";
      if (this.eForceBaseURL) {
        baseUrl = this.eForceBaseURL.replace(/\/$/, '');
      }

      // Check for explicit port specification, e.g. :4300/project/...
      const portMatch = requestURL.match(/^:(\d+)(.*)$/);
      if (portMatch) {
        const port = portMatch[1];
        let path = portMatch[2];
        if (!path.startsWith('/')) {
          path = '/' + path;
        }
        finalURL = `${baseUrl}:${port}${path}`;
      } else {
        let cleanPath = requestURL;
        if (cleanPath.startsWith('/')) {
          cleanPath = cleanPath.substring(1);
        }
        // Auto-detect project/ or projects/ to append port 4300
        if (cleanPath.includes('project/') || cleanPath.includes('projects/')) {
          finalURL = `${baseUrl}:4300/${cleanPath}`;
        } else {
          finalURL = `${baseUrl}/${cleanPath}`;
        }
      }
    }

    finalURL = this.sanitizeURL(finalURL);

    // for post request(adding)..
    if (requestType === 'post') {
      return this.http.post(finalURL, requestBody);
    }

    // for get request..
    if (requestType === 'get') {
      return this.http.get(finalURL);
    }
  }


  whatsappReport(requestType: string, requestURL: string, requestBody: any)
  {
    let finalURL = "https://eforce-api.cap-tech.in" + requestURL;
    finalURL = this.sanitizeURL(finalURL);
    if (requestType === 'get') {
      return this.http.get(finalURL);
     
    }
  }


  KYCimgUpload(requestType: string, requestURL: string, requestBody: any) {
    let finalURL = "";
    if (requestURL.startsWith('http://') || requestURL.startsWith('https://')) {
      finalURL = requestURL;
    } else {
      finalURL = "https://eforce-api.cap-tech.in/" + (requestURL.startsWith('/') ? requestURL.substring(1) : requestURL);
    }
    finalURL = this.sanitizeURL(finalURL);

    // for post request(adding)..
    if (requestType === 'post') {
      return this.http.post(finalURL, requestBody);
    }
    if (requestType === 'patch') {
      return this.http.patch(finalURL, requestBody);
    }

    // for get request..
    if (requestType === 'get') {
        return this.http.get(finalURL);
    }
  }


  // pan and gst verification


  getPanVerification(data) {
    return this.http.post("https://eforce.cap-tech.in:4810/pan_verify/", data)
    // return this.http.post("https://eforce-api.cap-tech.in/pan_verify/", data)
  }

  getGstVerification(data) {
    return this.http.post("https://eforce.cap-tech.in:4810/gst_verify/", data)
    // return this.http.post("https://eforce-api.cap-tech.in/gst_verify/", data)
  }


  // temp api

  whatsappIntegration(url)
  {
    let finalURL = this.eForceBaseURL + '/whatsapp/get-template/?is_active=True' + url;
    finalURL = this.sanitizeURL(finalURL);
    return this.http.get(finalURL);
  }


  whatsappNotification(requestURL:string)
  {
      requestURL = this.sanitizeURL(requestURL);
      return this.http.get(requestURL,{ headers: whatAppheaders});
  }


  tokenInfo() {
    return JSON.parse(localStorage.getItem('user_data'))
  }


  kycAutomation(requestType: string, requestURL: string, requestBody: any) {

    let finalURL = this.eForceBaseURL + '/kyc/' + (requestURL.startsWith('/') ? requestURL.substring(1) : requestURL);
    finalURL = this.sanitizeURL(finalURL);

    if (requestType === 'post') {
      return this.http.post(finalURL, requestBody);
    }

    // for get request..
    if (requestType === 'get') {
       return this.http.get(finalURL);
    }
    // for get request..
    if (requestType === 'put') {
      return this.http.patch(finalURL, requestBody);
    }


  }


}
